"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
// API
var DomainAPI_1 = require("@src/api/DomainAPI");
var store_1 = __importDefault(require("@src/store"));
var const_1 = require("@src/const");
var LoaderModal_1 = __importDefault(require("@src/components/LoaderModal"));
var PreviewTransferModal_1 = __importDefault(require("../PreviewTransferModal"));
var ReviewChangesModal_1 = __importDefault(require("../ReviewChangesModal"));
var EmptyTransferModal_1 = __importDefault(require("../EmptyTransferModal"));
var controller = new AbortController();
var PreviewTransferButton = function (_a) {
    var domainTitle = _a.domainTitle, trainStatus = _a.trainStatus, onTransferClick = _a.onTransferClick, previewModalActive = _a.previewModalActive, onPreviewModalClose = _a.onPreviewModalClose;
    var _b = react_1.useState(false), showLoading = _b[0], setShowLoading = _b[1];
    var _c = react_1.useState(false), showPreviewModal = _c[0], setShowPreviewModal = _c[1];
    var _d = react_1.useState(null), preview_data = _d[0], setPreview_data = _d[1];
    var _e = react_1.useState(null), preview_meta = _e[0], setPreview_meta = _e[1];
    var _f = react_1.useState(false), showEmptyTransferModal = _f[0], setShowEmptyTransferModal = _f[1];
    var _g = react_1.useState(false), reviewChangesModalActive = _g[0], setReviewChangesModalActive = _g[1];
    var mixPanelTracker = store_1["default"].getMixPanel();
    var handleTransferClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, DomainAPI_1.validatePreviewTransfer(domainTitle, preview_meta.preview_created_at)];
                case 1:
                    res = _a.sent();
                    if (res.response.error === '') {
                        onTransferClick();
                    }
                    else {
                        setReviewChangesModalActive(true);
                        mixPanelTracker.track({
                            event: const_1.MIX_PANEL.PREVIEW_TRANSFER.MERGE_CONFLICT,
                            payload: {
                                transferMergeConflict: true,
                            },
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var confirmTransfer = function () {
        setShowPreviewModal(false);
        onPreviewModalClose();
        setReviewChangesModalActive(false);
        mixPanelTracker.track({
            event: const_1.MIX_PANEL.PREVIEW_TRANSFER.TRANSFER_CLICKED,
            payload: {
                transferClicked: true,
            },
        });
        handleTransferClick();
    };
    var refreshPreview = function () {
        setReviewChangesModalActive(false);
        getData();
        mixPanelTracker.track({
            event: const_1.MIX_PANEL.PREVIEW_TRANSFER.MERGE_CONFLICT_REFRESHED,
            payload: {
                'previewRefreshed ': true,
            },
        });
    };
    var openPreviewModal = function (res, meta) {
        setPreview_data(res);
        setPreview_meta(meta);
        if (res) {
            if (res.contributors) {
                mixPanelTracker.track({
                    event: const_1.MIX_PANEL.PREVIEW_TRANSFER.TOTAL_CONTRIBUTORS,
                    payload: {
                        totalContributors: Object.keys(res.contributors).length,
                    },
                });
            }
            if (res.entities && Object.keys(res.entities).length) {
                mixPanelTracker.track({
                    event: const_1.MIX_PANEL.PREVIEW_TRANSFER.ENTITY_CHANGES_PRESENT,
                    payload: {
                        entityChangesPresent: true,
                    },
                });
            }
            if (res.skillsets && Object.keys(res.skillsets).length) {
                mixPanelTracker.track({
                    event: const_1.MIX_PANEL.PREVIEW_TRANSFER.SKILLSET_CHANGES_PRESENT,
                    payload: {
                        skillsetChangesPresent: true,
                    },
                });
            }
            if (res.general_nodes && Object.keys(res.general_nodes).length) {
                mixPanelTracker.track({
                    event: const_1.MIX_PANEL.PREVIEW_TRANSFER.FAQ_CHANGES_PRESENT,
                    payload: {
                        faqChangesPresent: true,
                    },
                });
            }
        }
    };
    var getData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShowLoading(true);
                    controller = new AbortController();
                    return [4 /*yield*/, DomainAPI_1.getVersioning(domainTitle, controller.signal)];
                case 1:
                    res = _a.sent();
                    setShowLoading(false);
                    data = res.response.body;
                    if (Object.keys(data.entities).length > 0 ||
                        Object.keys(data.skillsets).length > 0 ||
                        Object.keys(data.general_nodes).length ||
                        Object.keys(data.bot_synonyms).length > 0) {
                        openPreviewModal(res.response.body, res.response.meta);
                        mixPanelTracker.track({
                            event: const_1.MIX_PANEL.PREVIEW_TRANSFER.PREVIEW_TRANSFER_TRIGGERED,
                            payload: {
                                triggered: true,
                            },
                        });
                    }
                    else {
                        setShowEmptyTransferModal(true);
                        mixPanelTracker.track({
                            event: const_1.MIX_PANEL.PREVIEW_TRANSFER.EMPTY_SCREEN,
                            payload: {
                                emptyScreen: true,
                            },
                        });
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var closeLoader = function () {
        controller.abort();
        setShowLoading(false);
        mixPanelTracker.track({
            event: const_1.MIX_PANEL.PREVIEW_TRANSFER.LOADING_CANCELLED,
            payload: {
                loadingCancelled: true,
            },
        });
    };
    react_1.useEffect(function () {
        // Used to refresh preview and trigger preview modal
        if (preview_data && preview_data.contributors) {
            setShowPreviewModal(true);
        }
    }, [preview_data]);
    react_1.useEffect(function () {
        // Used to show preview modal again on view preview click
        if (previewModalActive) {
            if (preview_data && preview_data.contributors) {
                setShowPreviewModal(true);
            }
            else {
                setShowEmptyTransferModal(true);
                mixPanelTracker.track({
                    event: const_1.MIX_PANEL.PREVIEW_TRANSFER.EMPTY_SCREEN,
                    payload: {
                        emptyScreen: true,
                    },
                });
            }
        }
    }, [previewModalActive]);
    return (react_1["default"].createElement("div", { className: "transferButton" },
        react_1["default"].createElement(LoaderModal_1["default"], { closeModal: closeLoader, modalActive: showLoading }),
        react_1["default"].createElement(PreviewTransferModal_1["default"], { modalActive: showPreviewModal, onTransferClick: confirmTransfer, trainStatus: trainStatus, previewData: preview_data || {}, previewMeta: preview_meta || {}, closeModal: function () {
                setShowPreviewModal(false);
                onPreviewModalClose();
            } }),
        react_1["default"].createElement(EmptyTransferModal_1["default"], { modalActive: showEmptyTransferModal, closeModal: function () { return setShowEmptyTransferModal(false); } }),
        react_1["default"].createElement(ReviewChangesModal_1["default"], { onPreviewClick: refreshPreview, onTransferClick: confirmTransfer, modalActive: reviewChangesModalActive, closeModal: function () { return setReviewChangesModalActive(false); } }),
        react_1["default"].createElement(button_1["default"], { onClick: function () { return getData(); }, size: "big", type: button_1["default"].TYPES.OUTLINE }, "Preview & Transfer")));
};
exports["default"] = PreviewTransferButton;
